import React from 'react'
import { authRoles } from '../../auth/authRoles'

const dashboardAdminRoutes = [
    {
        path: '/dashboard',
        component: React.lazy(() => import('./Dashboard')),
        auth: authRoles.admin,
    },
    // {
    //     path: '/dashboard',
    //     component: React.lazy(() => import('./Analytics')),
    //     auth: authRoles.sa,
    // },
    {
        path: '/administracao/dashboard',
        component: React.lazy(() => import('./Analytics2')),
        auth: authRoles.admin,
    },
    {
        path: '/administracao/aniversarios',
        component: React.lazy(() => import('./Aniversarios/lista/MyTable')),
        auth: authRoles.admin,
    }
]

export default dashboardAdminRoutes
